<template>
  <div>
    <!-- THANK YOU MODAL -->
    <generic-modal
      v-if="showThankYouModal"
      @close="closeThankYouModal"
      :height="thankYouModalDim.height"
      :width="thankYouModalDim.width"
      :modalClass="thankYouModalDim.modalClass"
      :contentScroll="false"
    >
      <template v-slot:header> </template>
      <template v-slot:body>
        <div class="lottie-confetti dt-lottie-success">
          <VueLottiePlayer
            name="confettiAnim"
            :width="lottieSize.width"
            :height="lottieSize.height"
            :animationData="confettiAnimation"
            @animControl="onConfettiAnimControl"
          />
        </div>

        <div class="thank-you-body">
          <!-- <div class="thank-you-tick-container">
            <i class="hkfi-thank-you-tick"></i>
          </div> -->
          <div class="thank-you-text fs-16 mt62">
            Order confirmed. We’re bringin’ the crunch!
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal>

    <!-- LOADER -->
    <div v-else class="thank-you-loader">
      <VueLottiePlayer
        name="loaderAnim"
        :width="'100%'"
        :height="'100%'"
        loop
        :animationData="loaderAnimation"
      />

      <div class="center-alligned-text pt16">
        <!-- <div class="bold fs-16">Relax!</div> -->
        <div class="fs-16 tc color-slaty">Confirming your Order...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import GenericModal from "./GenericModal.vue";
import { clientPlatform } from "../config/apiEndpoints";
import Utility from "../helpers/utility";
import {
  keyMapsGetter,
  keyMapsAction,
  keyMapsMutation,
} from "../helpers/storeKeys";
import LocalStorageFunc from "../helpers/localStorageFunc";

export default {
  name: "ThankYou",

  components: {
    VueLottiePlayer: defineAsyncComponent(() => import("vue-lottie-player")),
    GenericModal,
  },

  data() {
    return {
      clientPlatform,
      thankYouModalDim: {
        width: "100vw",
        height: "100vh",
        modalClass: "full-screen-popup thank-you-wrap",
      },
      confettiAnimation: require("../assets/ConfettiOrderSuccessful.json"),
      loaderAnimation: require("../assets/hongs-order-tracker.json"),
    };
  },

  mounted() {
    let queryParams = Utility.getQueryFromUrl();
    if (queryParams["transactionId"]) {
      setTimeout(() => {
        this.$store.dispatch(keyMapsAction.POST_SUBMIT_TRACK_ORDER, {
          transactionId: queryParams["transactionId"],
        });
      }, 2000);
    }
    LocalStorageFunc.emptyCart();
  },

  methods: {
    closeThankYouModal() {
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_THANK_YOU_MODAL, false);
    },
    onConfettiAnimControl(anim) {
      anim.addEventListener("complete", this.redirectToOrderTracking);
    },
    redirectToOrderTracking() {
      let queryParams = Utility.getQueryFromUrl();
      if (queryParams["transactionId"]) {
        Utility.sendToOrderTracking(queryParams["transactionId"]);
      }
    },
  },

  computed: {
    showThankYouModal() {
      return this.$store.getters[keyMapsGetter.GET_SHOW_THANK_YOU_MODAL];
    },

    lottieSize() {
      return this.clientPlatform !== "Web"
        ? { width: "100%", height: "100%" }
        : { width: "80%", height: "80%" };
    },
  },
};
</script>
